import type { GameMeta } from "../../common/gameMeta.js";
import type { AuctionHouseVariantConfig } from "./variantConfig.js";

export const meta = {
	name: "Auction House",
	minPlayers: 1,
	maxPlayers: 8,
	description: "Secretly bid tokens on prizes. Highest unique bid wins.",
	instructions: `
Each round a prize is revealed. Secretly bid 1–10 tokens on it.
The highest UNIQUE bid wins the prize and its victory points.
Ties win nothing — and lose their tokens.
Everyone else gets their tokens back.
Most victory points after 6 rounds wins!
	`.trim(),
	mobileBrowserCompatible: true,
	showScores: false,
	modifiers: [
		{
			id: "merciful",
			label: "Merciful",
			instructions: "Ties are refunded — no prize, but at least you keep your tokens.",
			config: { tiesRefunded: true } satisfies AuctionHouseVariantConfig,
		},
	],
} satisfies GameMeta;
